<script>
import Endpoints from '../../../../components/common/Endpoints'
import Common from '../../../../components/common/Common'
import Request from '../../../../components/common/Request'

export default {
    init: payload => {
        const el = document.body
        el.removeAttribute('class')
        $('.modal').modal('hide')

        setTimeout(async function () {
            Request.do(
                payload,
                'GET',
                Request.getDefaultHeader(payload),
                null,
                `${Endpoints.parts.families.family}`,
                response => {
                    //SUCCESS CALLBACK
                    payload.families = response.results
                },
                error => {
                    //ERROR CALLBACK
                    console.log(error)
                },
            )
        }, 100)
    },
    methods: {
        search: async function () {
            $('#spinner').modal('toggle')

            let state = this
            let data = JSON.parse(JSON.stringify(this.data))

            data.searchArea = state.searchArea * 1000
            if (data.geolocation && data.geolocation.latitude && data.geolocation.longitude) {
                data.latitude = data.geolocation.latitude
                data.longitude = data.geolocation.longitude
            }

            data.systemUser = data.trucker

            try {
                setTimeout(async function () {
                    await Request.do(
                        state,
                        'POST',
                        Request.getDefaultHeader(state),
                        data,
                        `${Endpoints.orders.order}`,
                        response => {
                            //SUCCESS CALLBACK
                            $('#spinner').modal('toggle')
                            state.flashMessage.success(
                                state.configMessage(state.$t('string.msg.fleet.driver.order.title.success'), state.$t('string.msg.fleet.driver.order.message.success'), 'top left', 6000),
                                {
                                    mounted: state.showText(state.$t('string.msg.fleet.driver.order.message.success')),
                                    destroyed: state.clearText(),
                                },
                            )
                            this.clearForm()
                        },
                        error => {
                            //ERROR CALLBACK
                        },
                    )
                }, 3000)
            } catch (error) {}
        },
        redirectToMyOrders() {
            this.$router.push({ path: '/list-orders' })
            window.location.href = '?#/list-orders'
        },
        getAddressData: function (geo, placeResultData) {
            let state = this
            const locale = {
                address: placeResultData.formatted_address,
                geolocation: {
                    latitude: geo.latitude,
                    longitude: geo.longitude,
                },
            }

            state.data.locale = locale
            state.data.latitude = locale.geolocation.latitude
            state.data.longitude = locale.geolocation.longitude
        },
        checkForm: async function (e) {
            this.errors = []

            if (!this.truckType) {
                this.errors.push(this.$t('response.orders.fleet.vehicle.required'))
            }
            if (!this.data.manufacturer) {
                this.errors.push(this.$t('response.orders.fleet.manufacturer.required'))
            }
            if (!this.data.family) {
                this.errors.push(this.$t('response.orders.fleet.family.required'))
            }
            if (!this.data.description) {
                this.errors.push(this.$t('response.orders.fleet.description.required'))
            }
            if (this.searchArea == 0) {
                this.errors.push(this.$t('response.orders.fleet.search.required'))
            }
            if (!this.data.trucker) {
                this.errors.push(this.$t('response.orders.fleet.trucker.required'))
            }
            if (!this.data.truck) {
                this.errors.push(this.$t('response.orders.fleet.truck.required'))
            }

            if (this.errors.length > 0) {
                e.preventDefault()
            } else {
                try {
                    await this.search()
                } catch (error) {}
            }
        },
        findTruck: function () {
            let state = this
            state.data.truck = null
            if (state.truckType && state.truckType === 'TRUCK') {
                state.filters.vehicleTypes = state.truckTypes

                setTimeout(async function () {
                    let responseManu = (await Request.do(state, 'POST', Request.getDefaultHeader(state), { type: 'TRUCK' }, `${Endpoints.parts.manufacturer.listByType}`)).data
                    state.manufacturers = responseManu.results

                    let index = state.manufacturers.findIndex(x => x.name == 'OUTROS')
                    let others = null
                    if (index > -1) {
                        others = state.manufacturers[index]
                        state.manufacturers.splice(index, 1)
                        state.manufacturers.push(others)
                    }

                    Request.do(
                        state,
                        'POST',
                        Request.getDefaultHeader(state),
                        state.filters,
                        `${Endpoints.trucks.filter}`,
                        response => {
                            //SUCCESS CALLBACK
                            state.trucks = response.results
                        },
                        error => {
                            //ERROR CALLBACK
                            return null
                        },
                    )
                }, 100)
            } else if (state.truckType && state.truckType == 'TRUCK_TRAILER') {
                state.filters.vehicleTypes = state.truckTrailerTypes

                setTimeout(async function () {
                    let responseManu = (await Request.do(state, 'POST', Request.getDefaultHeader(state), { type: 'TRUCK_TRAILER' }, `${Endpoints.parts.manufacturer.listByType}`)).data
                    state.manufacturers = responseManu.results

                    let index = state.manufacturers.findIndex(x => x.name == 'OUTROS')
                    let others = null
                    if (index > -1) {
                        others = state.manufacturers[index]
                        state.manufacturers.splice(index, 1)
                        state.manufacturers.push(others)
                    }

                    Request.do(
                        state,
                        'POST',
                        Request.getDefaultHeader(state),
                        state.filters,
                        `${Endpoints.trucks.filter}`,
                        response => {
                            //SUCCESS CALLBACK
                            state.trucks = response.results
                        },
                        error => {
                            //ERROR CALLBACK
                            return null
                        },
                    )
                }, 100)
            }
        },
        clearForm() {
            this.data = {
                searchArea: 0,
                truck: null,
                manufacturer: null,
                family: null,
                systemUser: null,
                trucker: null,
                description: null,
                typeOrder: 'PARTS',
                latitude: 0,
                longitude: 0,
                statusOrder: 'WAITING_FOR_RESPONSE',
                locale: {
                    address: null,
                    geolocation: {
                        latitude: null,
                        longitude: null,
                    },
                },
            }
            this.orderHolder = {}
            this.truckType = null
            this.address = {
                state: -1,
                cep: null,
                city: null,
                address: null,
                neighborhood: null,
                number: null,
            }
        },
        showText(text) {
            this.text = text
        },
        clearText() {
            setTimeout(() => (this.text = ''), 500)
        },
        configMessage: function (title, message, position, time) {
            const config = {
                title: title,
                message: message,
                position: position,
                x: window.innerWidth / 60,
                y: window.innerHeight / 1.3,
                time: time,
            }
            return config
        },
        camelize: Common.camelize,
        toUpperCase: Common.toUpperCase,
    },
}
</script>
